import { Component, computed, input, model, output, signal } from '@angular/core';

import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { finalize } from 'rxjs';
import { LocationService } from '../../../services/location/location.service';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { Location } from '../../../shared/models/location.model';
import { LocationFormComponent } from '../../forms/location-form/location-form.component';
import { WorldMapComponent } from '../../world-map/world-map.component';

@Component({
  selector: 'app-location-modal',
  imports: [
    ModalComponent,
    LocationFormComponent,
    WorldMapComponent,
    ButtonModule
  ],
  templateUrl: './location-modal.component.html',
  styleUrl: './location-modal.component.scss'
})
export class LocationModalComponent {
  readonly isDelete = input.required<boolean>();
  readonly location = input.required<Location | null>();
  readonly isLoading = signal<boolean>(false);
  readonly success = output<Location | null>();

  constructor(
    private readonly messageService: MessageService,
    private readonly locationService: LocationService
  ) {}

  readonly coords = computed(() => {
    const location = this.location();
    return location?.latitude && location?.longitude ? {
      latitude: parseFloat(location?.latitude),
      longitude: parseFloat(location?.longitude)
    } : null;
  });
  readonly isOpen = model.required<boolean>();

  onCloseModal(): void {
    this.isOpen.set(false);
  }

    deleteLocation(): void {
      this.isLoading.set(true);

      this.locationService.deleteLocation(this.location()!.id!)
        .pipe(finalize(() => this.isLoading.set(false)))
        .subscribe({
          next: () => {
            this.isLoading.set(false);
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Localização apagada com sucesso!',
              life: 4000
            });
            this.success.emit(null);
            this.onCloseModal();
          },
          error: () => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Falha ao apagar localização!',
              life: 4000
            });
          }
        });
    }
}
